import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Sidebar from 'react-sidebar'
import get from 'lodash/get'
import some from 'lodash/some'
import * as FullStory from '@fullstory/browser'

import { withRouter } from 'react-router-dom'
import emitter from '../../../utils/emitter'
import store from '../../../store/configureStore'
import animations from '../../../utils/animations'
import { RESET } from '../../../store/rootReducer'
import LeftDrawerNavLink from './components/LeftDrawerNavLink'
import LeftDrawerHeader from './components/LeftDrawerHeader'
import accountUtils from '../../../utils/account/accountUtils'
import homeIcon from '../../../assets/icons/home.svg'
import assessmentIcon from '../../../assets/icons/assessment.svg'
import careerIcon from '../../../assets/icons/career.svg'
import logoutIcon from '../../../assets/icons/logout.svg'
import tuitionIcon from '../../../assets/icons/tuition.svg'
import peopleSearch from '../../../assets/icons/peopleSearchWhite.svg'
import dashboard from '../../../assets/icons/dashboard.svg'
import outcomesIcon from '../../../assets/icons/outcomes.svg'
import intercom from '../../../utils/intercom/intercomUtils'
import { getInsTokenModules } from '../../../routes/unauthenticated/Onboarding/insTokenDuck'
import API from '../../../utils/http/api'
import { ACCOUNTS_ENDPOINTS } from '../../../utils/constants/endpoints';

const mql = window.matchMedia(`(min-width: 800px)`)

const sidebarStyles = {
  root: {},
  sidebar: {
    width: '225px',
    color: '#545857',
    height: '100%',
    backgroundColor: '#f6f7f9',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: 'none',
  },
  content: {},
  overlay: {},
  dragHandle: {
    width: 0,
  },
}

const LINKS = [
  { path: '/app/dashboard', content: 'Home', icon: homeIcon },
  {
    path: '/app/personality-assessment',
    content: 'Personality',
    icon: assessmentIcon,
  },
  {
    path: '/app/outcomes',
    content: 'Outcomes',
    label: 'Outcomes',
    icon: outcomesIcon,
  },
  {
    path: '/app/search',
    content: 'Career-Paths',
    icon: peopleSearch,
    label: 'Search360°',
  },
  { path: '/app/tuition', content: 'Tuition', icon: tuitionIcon },
  { path: '/app/jobs', content: 'Job-Board', icon: careerIcon },
]

class LeftDrawer extends Component {
  static propTypes = {
    children: PropTypes.element.isRequired,
    history: PropTypes.any.isRequired,
    location: PropTypes.any.isRequired,
  }

  constructor(props) {
    super(props)

    this.state = {
      mql,
      open: false,
    }

    this.mediaQueryChanged = () => {
      const { matches } = this.state.mql
      this.setState({ sidebarDocked: this.state.mql.matches })
      emitter.emit('SIDEBAR::CHANGE', !matches)
    }

    this.onSetSidebarOpen = open => this.setState({ open })

    this.handleLogout = () => {
      const { login } = store.getState()
      if (get(login, 'universityData.universityLogoutUrl')) {
        console.log('sso logout')
        const shortName = window.location.hostname.split('.')[0]
        API.get(`${ACCOUNTS_ENDPOINTS.ssoLogout}/${shortName}`).catch(() => {})
      }

      FullStory.anonymize()
      FullStory.shutdown()
      store.dispatch({ type: RESET })
      this.props.history.push('/login')

      // End intercom session for the user and start a fresh session
      intercom.intercomEndSession()
      intercom.intercomStartFreshSession()
    }
  }

  componentWillMount() {
    mql.addListener(this.mediaQueryChanged)
    emitter.on('SIDEBAR::OPEN', () => this.onSetSidebarOpen(true))
    this.setState({ mql, sidebarDocked: mql.matches })
  }

  componentDidMount() {
    animations.createTimelineFadeAnimation({
      elementIds: LINKS.map(link => `#left-drawer-nav-link-${link.content}`).concat([
        '#left-drawer-nav-link-Profile',
        '#left-drawer-nav-link-logout',
      ]),
      delay: 0.5,
    })
  }

  componentWillUnmount() {
    this.state.mql.removeListener(this.mediaQueryChanged)
  }

  render() {
    const {
      currentUser: { user },
    } = store.getState()

    const mustMakePayment = accountUtils.mustUpdatePayment(user)
    const mustRecreateSubscription = accountUtils.mustRecreateSubscription(user)

    const allowedModules = getInsTokenModules(store.getState())

    let links = []

    if (accountUtils.isAbleToBeOnAdminDashboard(user)) {
      links = [
        { path: '/app/admin', content: 'Admin-Home', label: 'Admin-Home', icon: dashboard },
      ].concat(LINKS)
    } else if (accountUtils.isAbleToBeOnParentDashboard(user)) {
      links = [
        { path: '/app/parent', content: 'Parent-Home', label: 'Parent-Home', icon: dashboard },
      ].concat(LINKS)
    } else {
      links = LINKS
    }

    if (allowedModules && allowedModules.length > 0) {
      links = LINKS.filter(link => allowedModules.indexOf(link.content) !== -1)
    }

    if (accountUtils.isAbleToAccessDemo(user)) {
      if (!some(links, { path: '/app/demo', content: 'Demo', label: 'Demo', icon: dashboard })) {
        links.push({ path: '/app/demo', content: 'Demo', label: 'Demo', icon: dashboard })
      }
    }

    const sidebarContent = (
      <div style={sidebarStyles.sidebar}>
        <LeftDrawerHeader path={this.props.location.pathname} />
        {links.map(link => (
          <LeftDrawerNavLink
            key={link.path}
            disabled={mustMakePayment || mustRecreateSubscription}
            path={link.path}
            content={link.content}
            icon={link.icon}
            label={link.label}
          />
        ))}
        <div style={{ marginTop: 'auto' }} />

        <button
          id="left-drawer-nav-link-logout"
          className="btn"
          style={{
            width: '100%',
            textAlign: 'left',
            paddingRight: 0,
            paddingLeft: 15,
            marginTop: -10,
            color: '#545857',
            fontWeight: 400,
          }}
          onClick={this.handleLogout}
        >
          <span style={{ width: '100%', textAlign: 'left' }}>
            <img
              src={logoutIcon}
              alt="logout"
              style={{
                filter: 'invert(67%)',
                padding: '0',
                marginTop: -5,
                width: '100%',
                maxHeight: 25,
                maxWidth: 25,
                height: 'auto',
                objectFit: 'contain',
                objectPosition: 'center',
                marginRight: 15,
              }}
            />
            Log Out
          </span>
        </button>
      </div>
    )

    return (
      <Sidebar
        sidebar={sidebarContent}
        open={this.state.open}
        docked={this.state.sidebarDocked}
        onSetOpen={this.onSetSidebarOpen}
        styles={sidebarStyles}
        shadow={false}
      >
        {this.props.children}
      </Sidebar>
    )
  }
}

export default withRouter(LeftDrawer)



// WEBPACK FOOTER //
// ./src/components/ui/drawer/LeftDrawer.js